<script>
export default {
  name: 'MasonryCards.vue',
  props: ['content', 'noResultsText', 'variant', 'mini'],
  computed: {
    noResults: function() {
      return this.noResultsText ? this.noResultsText : 'No content to display.'
    },
    cardColor: function() {
      if (this.variant == 'blue') {
        return 'masonry-card-blue'
      } else if (this.variant == 'red') {
        return 'masonry-card-red'
      } else {
        return 'masonry-card-green'
      }
    },
    minified: function() {
      return this.mini == 'true'
    }
  },
  methods: {
    bodyClick: function(value) {
      this.$emit('bodyClick', value)
    },
    leftIconClick: function(value) {
      this.$emit('leftIconClick', value)
    },
    rightIconClick: function(value) {
      this.$emit('rightIconClick', value)
    }
  }
}
</script>

<template>
  <div>
    <div v-if="content.length == 0" id="no-results">{{ noResults }}</div>
    <b-card-group columns>
      <div v-for="element in content" :key="element.title">
        <b-card
          class="masonry-card"
          :class="cardColor"
          @click="bodyClick(element.data)"
        >
          <h4 slot="header">
            <b-card-title>
              {{ element.title.toUpperCase() }}
              <span v-if="minified" class="minified-text">{{
                element.text
              }}</span>
            </b-card-title>
          </h4>

          <b-card-body v-if="!minified">
            <b-card-text>{{ element.text }}</b-card-text>
          </b-card-body>

          <b-card-footer>
            <div id="footer-text">{{ element.footerText }}</div>
            <font-awesome-icon
              class="masonry-card-icon-left"
              v-if="element.icon_left"
              :icon="element.icon_left"
              v-b-tooltip.left="element.icon_left_tooltip"
              @click="leftIconClick(element.data)"
            />
            <font-awesome-icon
              class="masonry-card-icon-right"
              v-if="element.icon_right"
              :icon="element.icon_right"
              v-b-tooltip.left="element.icon_right_tooltip"
              @click="rightIconClick(element.data)"
            />
          </b-card-footer>
        </b-card>
      </div>
    </b-card-group>
  </div>
</template>

<style scoped>
#no-results {
  text-align: center;
  font-size: 1.4em;
  padding-top: 48px;
}

.masonry-card-blue {
  background-color: #85afd6 !important;
}

.masonry-card-red {
  background-color: #eea082 !important;
}

.masonry-card-green {
  background-color: rgba(0, 188, 112, 0.5) !important;
}

.minified-text {
  font-weight: lighter;
}

.masonry-card-icon-left {
  margin-right: 18px;
}

#footer-text {
  font-size: 0.4em;
}
</style>
